namespace JupitersChoice {
    
    export class InitRemoveRoyalsAnimationCmd {

        @inject('AssetCache') _assetCache: Sapphire.AssetCache;
        @inject('ComponentManager') _componentManager: Sapphire.ComponentManager;
        @inject('EventManager') _eventManager: Sapphire.EventManager;
        @inject('GameStage') _gameStage: Sapphire.GameStage;
        @inject('StateModel') _stateModel: Sapphire.StateModel;
        @inject('OrientationModel') _orientationModel: Sapphire.OrientationModel;
        @inject('LayerManager') _layerManager: Sapphire.LayerManager;
        @inject('SoundManager') _soundManager: Sapphire.SoundManager;

        @inject('GameConfig') _config: Sapphire.GameConfig;
        @inject('GameServer') _gameServer: Sapphire.GameServer;
        
        execute(): void {
            const royalsContainer = this._componentManager.get('RoyalsContainer');
            
            const blackHole = this._componentManager.get('BlackHole');
            const reelGlow = this._componentManager.get(this._stateModel.currentSubgame+'RoyalsGlow');
            const lightningBorder = this._componentManager.get(this._stateModel.currentSubgame+'LightningBorder');

            var jupiterKey: string = this._stateModel.currentSubgame == 'BaseGame' ? 'JupiterBaseGame' : (this._orientationModel.isLandscape ? 'JupiterFreeGameLandscape' : 'JupiterFreeGamePortrait');

            const jupiterComponent: Sapphire.SpineAnimation = this._componentManager.get(jupiterKey);

            var sprites = [];

            var xPositions: number[] = [177, 413, 649, 885, 1121, 1357];

            var reelOptions: number[] = [0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5];

            var minY: number = 370;
            var maxY: number = 840;

            var yDiff: number = maxY-minY;

            var symbols: string[] = ['L1.png','L2.png','L3.png','L4.png'];

            var getRand = function(n: number){
                return Math.floor(Math.random()*n);
            }

            var royalsContainerOriginalY: number = royalsContainer.y;
            var blackHoleOriginalY: number = blackHole.y;

            if(this._stateModel.currentSubgame === 'FreeGame' && this._orientationModel.isPortrait){
                //move 2 elements
                royalsContainer.y += 193;
                blackHole.y += 193;
            }

            for(var i: number = 0; i <24; ++i){
                var idx = getRand(reelOptions.length);
                var reelIdx = reelOptions.splice(idx,1)[0];
                var sprite = new PIXI.Sprite(this._assetCache.getTexture('Reels', 'symbols', symbols[getRand(4)]));
                sprite.x = xPositions[reelIdx];
                sprite.y = minY + getRand(yDiff);
                sprite.pivot = new PIXI.Point(sprite.width / 2, sprite.height / 2);
                sprite.scale.set(1,1);
                sprite.visible = false;
                royalsContainer.addChild(sprite);
                sprites.push(sprite);
            }

            TweenMax.delayedCall(1,() => {

                jupiterComponent.changeAnimation('royals_intro',true,false,() => {
                    jupiterComponent.changeAnimation('royals_loop',false,true);
                });

                TweenMax.delayedCall(0.5,() => {
                    this._soundManager.play('reel_anticipation');
                    this._layerManager.setVisibility('MegaReel', true);
                    lightningBorder.play();
                    reelGlow.show();
                    blackHole.reset();
                    blackHole.play(() => {
                        blackHole.stop();
                    });

                    var timeOffset: number = 0.2;
                    var interval: number = 0.1;

                    var moveSpeed = 0.4;
                    var collapseSpeed = 0.3;
                    var shrinkDelay = 0.3;

                    sprites.forEach((sprite, idx) => {
                        
                        TweenMax.delayedCall(timeOffset, () => {
                            sprite.visible = true;
                            new TweenMax(sprite.scale, moveSpeed, {
                                x: 1.3,
                                y: 1.3
                            });
                            new TweenMax(sprite, moveSpeed, {
                                ease: Power4.easeIn,
                                x: 760,
                                y: 600
                            });
                            new TweenMax(sprite.scale, collapseSpeed, {
                                delay: shrinkDelay,
                                x: 0,
                                y: 0
                            });
                            new TweenMax(sprite, collapseSpeed, {
                                delay: shrinkDelay,
                                alpha:0
                            });
                        });
                        timeOffset += interval;
                    });

                    const response: any = this._gameServer.logicResponse;
                    const grids = this._config.get('external', 'grids');
                    const spinInfo = this._stateModel.currentSubgame === 'FreeGame' ?
                        response.freespins[ShowFreeGameCmd.currentFreeGameSpinIdx - 1] : response;
                    const reelsetType = grids[spinInfo.grid].reels;
                    const reels = this._componentManager.get('Reels');

                    for (let i = 0; i < 6; i++) {
                        let reelset = reelsetType[spinInfo.rawReelIndices[i]];
                        let startingIdx = Math.floor(Math.random() * reelset.length);
                        reels.updateStrip(i, reelset, false, startingIdx);
                    }


                    TweenMax.delayedCall(timeOffset-interval+collapseSpeed, () => {
                        
                        this._soundManager.stop('reel_anticipation');
                        this._soundManager.play('reel_anticipation_win');
                        jupiterComponent.changeAnimation('royals_win',true,false, () => {
                            jupiterComponent.changeAnimation('idle',false);
                            lightningBorder.stop();
                            lightningBorder.hide();
                            reelGlow.hide();
                            sprites.forEach(sprite => {
                                royalsContainer.removeChild(sprite);
                            });
                            if(this._stateModel.currentSubgame === 'FreeGame'){
                                //move 2 elements
                                royalsContainer.y = royalsContainerOriginalY;
                                blackHole.y = blackHoleOriginalY;
                            }
                            if(this._stateModel.currentSubgame == 'BaseGame'){
                                this._eventManager.publish('onMegaReelAnimationComplete');
                            }else if(this._stateModel.currentSubgame == 'FreeGame'){
                                this._eventManager.publish('onFreeGameMegaReelAnimationComplete');
                            }else {
                                Sapphire.Logger.warn('What are you doing? end of megareel not in base game OR free game?');
                            }
                        });

                    });
                });
            });
        }
    }
}